export default {"src":"/_next/static/media/FRFlag.21c1b47e.svg","height":18,"width":24};